// Topbar is disabled — its language switcher has moved into Navbar.
// Kept as a no-op so existing imports/usages don't break.
export default function Topbar() {
  return null;
}
